import { Store } from '@reduxjs/toolkit';
import { ReducersInjectorWithState, StoreType } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { CustomerCareState } from './customerCare/types';
import customerCareReducer from './customerCare/slices';
import { ReportProblemState } from './reportProblem/types';
import reportProblemReducer from './reportProblem/slices';
import { ContactUsState } from './contactUs/types';
import contactUsReducer from './contactUs/slices';
import { UsersState } from './users/types';
import usersReducer from './users/slices';
import { UsersAnalyticsState } from './usersAnalytics/types';
import usersAnalyticsReducer from './usersAnalytics/slices';
import { EventKeyMappingsState } from './eventKeyMappings/types';
import eventKeyMappingsReducer from './eventKeyMappings/slices';
import { FeedbackState } from './feedback';
import feedbackReducer from './feedback/slices';

export let customerStore: StoreType<{
  customerCare: CustomerCareState;
  reportProblem: ReportProblemState;
  contactUs: ContactUsState;
  users: UsersState;
  usersAnalytics: UsersAnalyticsState;
  eventKeyMappings: EventKeyMappingsState;
  feedback: FeedbackState;
}>;

// export type StoreType = typeof store;
export type CustomerDispatch = typeof customerStore.dispatch;
export type CustomerStoreState = ReturnType<typeof customerStore.getState>;
export const useCustomerDispatch = () => useDispatch<CustomerDispatch>();
export const useCustomerSelector: TypedUseSelectorHook<CustomerStoreState> =
  useSelector;
export const getCustomerState = (store: Store) =>
  store.getState() as CustomerStoreState;

export const injectCustomerReducers: ReducersInjectorWithState<
  CustomerStoreState
> = () => {
  return [
    {
      name: 'customerCare',
      reducer: customerCareReducer,
    },
    {
      name: 'reportProblem',
      reducer: reportProblemReducer,
    },
    {
      name: 'contactUs',
      reducer: contactUsReducer,
    },
    {
      name: 'users',
      reducer: usersReducer,
    },
    {
      name: 'usersAnalytics',
      reducer: usersAnalyticsReducer,
    },
    {
      name: 'eventKeyMappings',
      reducer: eventKeyMappingsReducer,
    },
    {
      name: 'feedback',
      reducer: feedbackReducer,
    },
  ];
};
